import { isValid } from 'domain/utils';
import { AuthorizationService } from 'domain/services';

import { Token, UploadConfig } from 'domain/models';

const _fetch = fetch;
export abstract class AuthorizedService {

  protected async fetch(
    input: RequestInfo,
    init?: RequestInit | undefined
  ): Promise<Response> {
    
    const validToken = await this.getValidToken();
    return this.delegate(input, init, validToken);
    // If fetch returns 403/401 try to refresh, if fails redirect to /auth
  }

  async getValidToken(): Promise<Token> {
    const token = AuthorizationService.getAuthorization();
    const [valid, remaining] = isValid(token);
    if (valid && remaining > 1000 * 300) {
      // 5 Minutes
      return token as Token;
    } else {
      const newToken = await new AuthorizationService().renew();
      return newToken;
    }
  }

  private delegate(
    input: RequestInfo,
    init: RequestInit | undefined = { headers: {} },
    token: Token
  ): Promise<Response> {
    return _fetch(input, {
      ...init,
      headers: {
        'Content-Type': 'application/json',
        ...init.headers,
        ...this.buildAuthorizationHeader(token)
      }
    });
  }

  private buildAuthorizationHeader(token: Token): { Authorization: string } {
    return { Authorization: `Bearer  ${token.token}` };
  }

  protected uploadFile(url: string, formData: any, onProgress?: any, config?: UploadConfig): Promise<any> {
    return new Promise((res, rej) => {
      const token = AuthorizationService.getAuthorization();
      const xhr = new XMLHttpRequest();
      xhr.open(config?.method || 'POST', url);
      xhr.setRequestHeader('Authorization', `Bearer ${token.token}`);
      if (onProgress) {
        xhr.upload.addEventListener('progress', onProgress);
      }
      xhr.onload = () => {
        const response = (config?.noJsonParse) ? xhr.response : JSON.parse(xhr.response);
        if (xhr.status >= 200 && xhr.status < 300) {
          res(response);
        } else {
          rej(response);
        }
      };
      xhr.onerror = () => rej(xhr.statusText);
      xhr.send(formData);
    });
  }

}